import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Customer from '../entities/customer'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface CustomerState extends ListState<Customer>{
    customer:Customer,
    selectCustomer:Customer,


}

class CustomerMutations extends ListMutations<Customer>{

}

class CustomerModule extends ListModule<CustomerState,any,Customer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Customer>(),
        loading:false,
        editCustomer:new Customer(),
        selectCustomer:new Customer(),
    
    
    }
    actions={

 
     
        async saveCustomer(context:ActionContext<CustomerState,any>,payload:any){
         
            context.state.loading=true;
            let reponse=await Ajax.post('/api/services/app/Customer/SaveCustomer',payload.data);
          
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Customer>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getCustomers(context:ActionContext<CustomerState,any>,payload:any){
            
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Customer/GetCustomers',payload.data);
          
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Customer>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:CustomerState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CustomerState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const customerModule=new CustomerModule();
export default customerModule;